<template>
  <div
    class="modal custom-modal fade check-availability-modal payment-success-modal"
    id="pages_edit"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="payment-success">
            <span class="check"><i class="fa-solid fa-check-double"></i></span>
            <h5>Order Confirmed</h5>
            <p>
              You Payment has been successfully done. Trasaction id :<span>
                #5064164454</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
